/**
 *  Module for global app state, components, and the main user interface
 */

const App = function (_configure, _mergedParams, _$container, utils, globalBuild, dispatcher, store, actions, initConfigure) {

  const _ = require('lodash');
  const $ = require('jquery');

  // Declare the app object so we can use it before it's fully defined otherwise jshint complains
  let app = {};
  const configure = _configure;
  const tools = require('@fluid.inc/imp-ui-helpers').utils(_mergedParams, _configure); // Fix for deprecated tools.helpers()

  function initComponents() {
    app.registerHook = require('./register_hook')(app);
    // Add components to the app object so they can be used globally
    app.actions = actions;
    app.appUtils = require('./app_utils')(app);
    app.additionalInformation = require('./additional_information')(app);
    app.createConfigure = require('./create_configure')(app);
    app.addedtocartdialog = require('@fluid.inc/imp-ui-addedtocartdialog')(app);
    app.helpers = tools; // Fix for deprecated tools.helpers()
    app.getRenderableAttributes = app.helpers.getRenderableAttributes;
    app.localizationDropDown = require('./localization_drop_down')();
    app.analytics = require('./analytics')(app);
    app.cart = require('./cart')(app);
    app.dispatcher = dispatcher;
    app.l10n = require('./localization')(app);
    app.menu = require('./menu')(app);
    app.monogram = require('./monogram/')(app);
    app.model = require('./model')(app);
    app.price = require('./price')(app);
    // app.startover = require('./startover')(app);
    app.store = store;
    app.thumbnails = require('./thumbnails')(app);
    app.zoom = require('./zoom')(app);
    app.jzoom = require('../utils/jquery-zoom')(app);
    // app.share = require('./share')(app);
    // app.print = require('./print')(app);
    // app.collapsable_areas = require('./collapsable_areas')();
    app.pinch_and_zoom = require('./pinch_and_zoom')();
    app.updateRecipeOms = require('./update_recipe_oms')(app);
    app.createDialog = require('@fluid.inc/imp-ui-dialog').DialogApp(app);
    app.horizontalPagination = require('./horizontal_pagination')(app);
    // Init Localization
    app.l10n.init();

    app.fixedPreview = require('./fixed_preview.js')(app);
    app.relatedProducts = require('./related_products')(app);

    app.performance.mark('configure:components:registered');
  }

  /**
   *  UI
   */

  function updateInstance(unavailable) {
    if (app.mergedParams.catalogOnly) {
      app.createConfigure.createCatalogUI();
    } else if (app.mergedParams.catalogAll) {
      app.createConfigure.createCatalogUI(true);
    } else {
      app.createConfigure.createConfigureUI(unavailable);
    }
  }

  function generateColorParam() {
    let url = window.location.href;
    const curr = app.helpers.getSelectedValueByAlias('oms_sku').vendorId;
    const omit = app.helpers.getUrlParam('omitValues');

    if (omit) {
      url = app.helpers.updateUrlParameter(url, 'omitValues', `${omit},${curr}`);
    } else {
      url = `${url}&omitValues=${curr}`;
    }

    window.location.href = url;
  }

  function renderUi(unavailable) {
    app.performance.mark('configure:ui:rendered');
    app.performance.logConfigureLoaded('Init', 'Page Load to Configure Init', 'configure:init');
    app.performance.record('Init', 'Configure Init to Render UI Start', ['configure:init', 'configure:ui:rendered']);

    // Initialize all components
    initComponents();

    // Create the UI
    updateInstance(unavailable);

    // Watch media queries and update DOM
    const sm = window.matchMedia('(min-width: 768px)'),
      md = window.matchMedia('(min-width: 1024px)'),
      lg = window.matchMedia('(min-width: 1224px)');

    sm.addListener(updateInstance);
    md.addListener(updateInstance);
    lg.addListener(updateInstance);

    app.performance.mark('configure:ui:end');
    app.performance.record('Init', 'Configure Init to Render UI Complete', ['configure:init', 'configure:ui:end']);
    app.performance.record('Init', 'Render UI and Components Process', ['configure:ui:rendered', 'configure:ui:end']);
    app.analytics.track('configure-loaded');
    fluidTimings.finish('initialize');
    console.timeEnd('Configure Loaded');

    if (app.mergedParams.generateColorParam) {
      generateColorParam();
    }
  }

  function init(unavailable, recipeDocument) {
    if (app.isFluidEnv()) {
      window._configure = configure;
      window.app = app;
      $('#fluidConfigure').addClass('fc-is-fluid-env');
    }
    $('#fluidConfigure').addClass(`fc-is-${app.mergedParams.locale}-locale`);
    app.availability = require('./availability')(app);
    app.product = configure.run('getProduct');
    app.category = app.utils.getFirstProductFacet('Product Category', app.product);
    app.projectName = app.utils.getFirstProductFacet('Project Name', app.product);
    app.attributes = configure.run('getAttributes');
    app.performance = require('./performance')(app);
    app.attributes = configure.run('getAttributes');
    app.recipeDocument = recipeDocument;

    if (!app.mergedParams.assetPath) {
      app.mergedParams.assetPath = app.mergedParams.buildType === 'cdn' ? app.globalBuild.getPathForLocation('asset_path_cdn', app.mergedParams.loc) : process.env.asset_path;
    }

    if (app.mergedParams.ola !== 'false' && app.mergedParams.ola !== false) {
      const availabilityCallback = function (data) {
        if (app.isFluidEnv()) {
          console.log('checkAvailability data', data);
        }

        app.performance.mark('configure:ola:end');
        app.performance.record('OLA', 'Total Process', ['configure:ola:start', 'configure:ola:end']);
        app.performance.record('OLA', 'File Downloaded', ['configure:ola:start', 'configure:ola:loaded']);
        app.performance.record('OLA', 'Data Processing', ['configure:ola:loaded', 'configure:ola:end']);

        // If we haven't set the productOverrides and the data coming back
        // has overrides defined
        if (_.isUndefined(app.mergedParams.productOverrides) &&
          _.size(data.values)) {
          // Add product overrides to the params

          app.mergedParams.productOverrides = data;

          // Set the On Load Availability flag to false
          // this will skip checking availability a second time
          app.mergedParams.ola = false;

          // Reload configure with product overrides in place
          initConfigure(app.mergedParams);
        } else {
          // Render the UI
          renderUi(unavailable);
        }
      };

      app.performance.mark(`configure:ola:start`);

      const ASIA_CATEGORIES = ['China CYO', 'China DTG', 'Asia CYO', 'Asia DTG', 'JP CYO', 'JP DTG'];
      if (ASIA_CATEGORIES.indexOf(app.category) !== -1 ||
        app.mergedParams.useAsiaFeed && app.mergedParams.fluidEnv) {
        const skus = configure.run('getAttribute', { alias: 'oms_sku' });
        const styleNumbers = skus.values.map(value => value.vendorId);

        app.availability.asia.checkAvailability(styleNumbers, availabilityCallback);
      } else {
        // we get the style numbers.
        const styleFacetsId = [];
        const styleNumbers = configure.run('getAttribute', { alias: 'oms_sku' }).allFacets.filter(function (facet) {
          return facet.name.indexOf('Style #') >= 0;
        })[0].facetValues.map(function (facetValue) {
          styleFacetsId.push(facetValue.id);
          return facetValue.name;
        }).join(',');
        // Check the RAL API against these SKUS and
        // handle any out of stock items
        app.availability.us_eu.checkAvailability(styleNumbers, styleFacetsId, availabilityCallback);
      }
    } else {
      // Render the UI
      renderUi(unavailable);
    }
  }

  function isFluidEnv() {
    return app.mergedParams.fluidEnv;
  }

  function isAppInstance() {
    return app.mergedParams.instance === 'app';
  }

  /**
   *  Expose Public Properties/Methods
   */
  app = {
    // Public Properies
    utils,
    globalBuild,

    _callback(err) { if (err) { throw err; } },

    // API reference
    configure: _configure,
    // jQuery object for the #fluidConfigure container
    $container: _$container,
    // Merged params object
    mergedParams: _mergedParams,

    // Public methods
    init,
    // getUpcharge: getUpcharge,
    isFluidEnv,
    isAppInstance
  };

  return app;
};

module.exports = App;
